import Color from 'color';

const white = '#FFFFFF';
const black = '#1A1919';

const bronze = '#C27100';

const grayText = '#858585';
const grayBg = '#F5F5F5';
const grayLight = '#E8E8E8';
const grayDisable = '#D5D5D5';
const grayDivider = '#C4C4C4';
const gray2 = '#525252';

const blue = '#0FA6C8';
const lightBlue = '#DAF8FF';

const greenMain = '#004876';
const greenDark = '#2f80b3';
const greenMiddle = '#006B72';

const softOrange = '#DEB65F';

const pink = '#FFDFDF';

const red = '#F2685F';
const redError = '#F44336';
const redErrorTransparent = Color(redError).alpha(0.23).string();

export default {
  black,
  white,

  bronze,

  grayText,
  grayBg,
  grayLight,
  grayDisable,
  grayDivider,
  gray2,

  blue,
  lightBlue,

  greenMain,
  greenDark,
  greenMiddle,

  softOrange,

  pink,

  red,
  redError,
  redErrorTransparent,
};
